import { ReactNode, FC } from 'react';
import cs from 'classnames';
import styles from './index.module.less';

interface IProps {
  text?: string | ReactNode;
  className?: any;
  imgClassname?: any;
  defaultImgUrl?: string;
  wrapperStyle?: any;
  textClassname?: any;
  children?: ReactNode;
}
const Empty: FC<IProps> = ({
  text = '页面走丢了',
  className,
  imgClassname,
  textClassname,
  wrapperStyle,
  defaultImgUrl = `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/store-developer/ic_kongzhuangtai@2x.png`,
  children
}) => {
  return (
    <div className={cs(styles.voidImgWrapper, className)} style={wrapperStyle}>
      <img className={cs(styles.voidImg, imgClassname)} src={defaultImgUrl} />
      {
        children || <div className={cs(styles.voidText, 'mt-12', textClassname)}>{text}</div>
      }
    </div>
  );
};

export default Empty;
